import { InjectionToken } from "@angular/core";
import { ILauncherVersionRestClient } from "./i-launcher-version-rest.client";

export const launcherVersionRestClientInjectionToken: InjectionToken<ILauncherVersionRestClient> = new InjectionToken<ILauncherVersionRestClient>( "digital-signage.developer-dashboard.dashboard-web.LauncherVersionRestClient" );
